module.exports = __webpack_public_path__ + "img/ball_4_black.553f2190.png";